<template>
  <div id="Financial">
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">گزارش مالی</h3>
        <CButton @click="filter=true" v-if="!filter" style="float: left;margin-left: 10px;margin-top: 10px">
          <CIcon  name="cil-filter" style="width: 30px;height: 30px;float: left;color: white;"/>
        </CButton>
        <CButton @click="[filter=false,GetTransaction(0,10)]" v-else style="float: left;margin-left: 10px;margin-top: 10px">
          <CIcon  name="cil-filter-x" style="width: 30px;height: 30px;float: left;color: white;"/>
        </CButton>
      </div>
      <div class="card-body">
        <CCollapse style="float: right;width: 100%;" :show="filter"  :duration="1000">
          <CCardBody style="float: right;width: 100%;height:200px; background: #2a2b36">
            <div>
              <CRow class="align-items-start" style="direction: rtl">
                <CCol>
                  <CSelect v-model="indexFleet" :options="FleetsOptions" label="ناو گان:" @change="SelectFleet($event.target.selectedIndex)" />
                </CCol>
                <CCol>
                  <CInput
                          label="شناسه:"
                          valid-feedback=""
                          invalid-feedback="حداقل شش  کارکتر لاتین"
                          value=""
                          v-model="Filter.ID"
                          :is-valid="true"
                  />
                </CCol>
                <CCol>
                  <CInput
                      label="شناسه تراکنش:"
                      valid-feedback=""
                      invalid-feedback="حداقل شش  کارکتر لاتین"
                      value=""
                      v-model="Filter.TransactionID"
                      :is-valid="true"
                  />
                </CCol>
                <CCol>
                  <CInput
                      label="تاریخ دریافت:"
                      valid-feedback=""
                      invalid-feedback="حداقل شش  کارکتر لاتین"
                      value=""
                      v-model="Filter.ReceiveDate"
                      :is-valid="true"
                  />
                </CCol>
                <CCol>
                  <CInput
                      label="موجودی:"
                      valid-feedback=""
                      invalid-feedback="حداقل شش  کارکتر لاتین"
                      value=""
                      v-model="Filter.Balance"
                      :is-valid="true"
                  />
                </CCol>
                <CCol>
                  <CCol>
                    <CInput
                        label="ctc:"
                        valid-feedback=""
                        invalid-feedback="حداقل شش  کارکتر لاتین"
                        value=""
                        v-model="Filter.CTC"
                        :is-valid="true"
                    />
                  </CCol>
                </CCol>
                <CCol>
                  <CInput
                      label="pan راننده:"
                      valid-feedback=""
                      invalid-feedback="حداقل شش  کارکتر لاتین"
                      value=""
                      v-model="Filter.DriverPan"
                      :is-valid="true"
                  />
                </CCol>
              </CRow>
              <CRow class="align-items-start" style="direction: rtl">
                <CCol>
                  <CSelect  :options="DevicesOptions" @change="SelectDevice($event.target.selectedIndex)" label="دستگاه:"  />
                </CCol>
                <CCol>
                  <CInput
                      label="RRN:"
                      valid-feedback=""
                      invalid-feedback="حداقل شش  کارکتر لاتین"
                      value=""
                      v-model="Filter.RRN"
                      :is-valid="true"
                  />
                </CCol>
                <CCol>
                  <CInput
                      label="شناسه حواله:"
                      valid-feedback=""
                      invalid-feedback="حداقل شش  کارکتر لاتین"
                      value=""
                      v-model="Filter.ReferredID"
                      :is-valid="true"
                  />
                </CCol>
                <CCol>
                  <CInput
                      label="شناسه حواله دسته ای:"
                      valid-feedback=""
                      invalid-feedback="حداقل شش  کارکتر لاتین"
                      value=""
                      v-model="Filter.ReferredIDGroup"
                      :is-valid="true"
                  />
                </CCol>
                <CCol>
                  <CInput
                      label=" شناسه پاسخ:"
                      valid-feedback=""
                      invalid-feedback="حداقل شش  کارکتر لاتین"
                      value=""
                      v-model="Filter.ResponseID"
                      :is-valid="true"
                  />
                </CCol>
                <CCol>
                  <CInput
                      label="شناسه مالی:"
                      valid-feedback=""
                      invalid-feedback="حداقل شش  کارکتر لاتین"
                      value=""
                      v-model="Filter.FinancialID"
                      :is-valid="true"
                  />
                </CCol>
                <CCol>
                  <CInput
                      label="Pan:"
                      valid-feedback=""
                      invalid-feedback="حداقل شش  کارکتر لاتین"
                      value=""
                      v-model="Filter.Pan"
                      :is-valid="true"
                  />
                </CCol>
              </CRow>
              <CRow class="align-items-start" style="direction: rtl">


                <CCol>
                  <CButton style="float: left;direction:rtl;margin-left: 5px" color="primary" @click="GetTransactionFilter(0,10)"><span style="float: left;font-size: 18px"> جستجو </span> &nbsp;&nbsp; <CIcon  name="cil-search" style="width: 25px;height: 25px;color: white;"/>&nbsp;&nbsp;&nbsp;</CButton>&nbsp;&nbsp;&nbsp;
                  <CButton style="float: left;direction:rtl;margin-left: 5px" color="warning" @click="[DialogMap=true,GetTransactionFilterMap(0,50000)]"><span style="float: left;font-size: 18px"> مشاهده روی نقشه </span> &nbsp;&nbsp; <CIcon  name="cil-map" style="width: 25px;height: 25px;color: white;"/>&nbsp;&nbsp;&nbsp;</CButton>&nbsp;&nbsp;&nbsp;
                  <CButton style="float: left;direction:rtl;margin-left: 5px" color="info" @click="[Filter.ID='',Filter.Ref='',Filter.Amount='',Filter.Balance='',Filter.CartID='',Filter.AccountID='',Filter.TerminalID='',Filter.MerchantID='',GetTransactionFilter(0,10)]"> <span style="float: left;font-size: 18px">بازنشانی</span> <CIcon  name="cil-action-undo" style="width: 25px;height: 25px;color: white;"/>&nbsp;&nbsp;&nbsp;</CButton>&nbsp;&nbsp;&nbsp;
                  <CButton style="float: left;direction:rtl;margin-left: 5px" color="danger" @click="[filter=false,GetTransaction(0,10)]"><span style="float: left;font-size: 18px">بستن</span> <CIcon  name="cil-filter-x" style="width: 25px;height: 25px;color: white;"/>&nbsp;&nbsp;&nbsp;</CButton>&nbsp;&nbsp;&nbsp;
                </CCol>

              </CRow>
            </div>

          </CCardBody>
        </CCollapse>
        <CDataTable

            :hover="true"
            :border="true"
            
            :striped="false"
            :loading="loading"
            :small="true"
            :items="Transaction.data"
            :fields="fieldObject"
            :tableFilterValue="TableFilter"
            :fixed="false"
            :items-per-page="10"
            pagination
            @row-clicked="SelectLog"
            style="float: right;width: 100%;overflow-x: scroll;margin-top: 20px;direction: rtl;"
            :noItemsView="{ noResults: 'چیزی یافت نشد.', noItems: 'چیزی برای نمایش وجود ندارد.' }"

        >
          <template #details="{item}">
            <CCollapse :show="item.bfl_id===indexDeviceLog"  :duration="500">
              <CCardBody style="float: right;width: 100%;height:400px ;border: 1px solid silver;margin-top:0px;">
                <div style="float: right;width: 60%;">
                  <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">شناسه پایانه</span>
                    <input class="form-control" disabled v-model="item.bfl_terminal_id" type="text" style="text-align: center;background: #212529;color: white" >
                  </div>
                  <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">کد پایانه</span>
                    <input class="form-control" disabled v-model="item.bfl_terminal_code" type="text" style="text-align: center;background: #212529;color: white" >
                  </div>
                  <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">pan راننده</span>
                    <input class="form-control" disabled v-model="item.bfl_driver_pan" type="text" style="text-align: center;background: #212529;color: white" >
                  </div>
                  <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">RRN</span>
                    <input class="form-control" disabled v-model="item.bfl_online_rrn" type="text" style="text-align: center;background: #212529;color: white" >
                  </div>
                  <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">شناسه حواله</span>
                    <input class="form-control" disabled v-model="item.bfl_draft_code" type="text" style="text-align: center;background: #212529;color: white" >
                  </div>
                  <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">شناسه دسته ای</span>
                    <input class="form-control" disabled v-model="item.bfl_group_draft_code" type="text" style="text-align: center;background: #212529;color: white" >
                  </div>
                  <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">شناسه پاسخ</span>
                    <input class="form-control" disabled v-model="item.bfl_response_code" type="text" style="text-align: center;background: #212529;color: white" >
                  </div>
                  <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">توضیح پاسخ</span>
                    <input class="form-control" disabled v-model="item.bfl_response_desc" type="text" style="text-align: center;background: #212529;color: white" >
                  </div>
                  <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">شناسه مالی</span>
                    <input class="form-control" disabled v-model="item.trn_service_point" type="text" style="text-align: center;background: #212529;color: white" >
                  </div>
                  <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">شناسه دستگاه</span>
                    <input class="form-control" disabled v-model="item.trn_service_point" type="text" style="text-align: center;background: #212529;color: white" >
                  </div>
                  <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">نوع</span>
                    <input class="form-control" disabled v-model="item.bfl_type" type="text" style="text-align: center;background: #212529;color: white" >
                  </div>
                  <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">PAN</span>
                    <input class="form-control" disabled v-model="item.bfl_pan" type="text" style="text-align: center;background: #212529;color: white" >
                  </div>
                  <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">عرض جغرافیایی</span>
                    <input class="form-control" disabled v-model="item.bfl_lat" type="text" style="text-align: center;background: #212529;color: white" >
                  </div>
                  <div class="input-group" style="direction: rtl;float: right;width: 300px;">
                    <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">طول جغرافیایی</span>
                    <input class="form-control" disabled v-model="item.bfl_long" type="text" style="text-align: center;background: #212529;color: white" >
                  </div>

                </div>
                <div style="float:left;width:40%;height: 90%;border:2px solid silver;border-radius: 7px;overflow: hidden" v-if="item.bfl_long!==null">
                  <l-map
                      ref="myMap"
                      v-if="item.bfl_id===indexDeviceLog && item.bfl_long!==null"
                      :zoom="zoom"
                      :center="center"
                      style="float:left;width:100%;height: 100%;"
                  >
                    <l-tile-layer
                        :url="url"
                        :attribution="attribution"
                    />
                    <l-wms-tile-layer
                      :key="wmsLayer.name"
                      :base-url="wmsLayer.url"
                      :layers="wmsLayer.layers"
                      :visible="wmsLayer.visible"
                      :name="wmsLayer.name"
                      :attribution="wmsLayer.attribution"
                      :transparent="true"
                      format="image/png"
                      layer-type="base">
                    </l-wms-tile-layer>

                    <l-marker ref="marker5"    :lat-lng="[item.bfl_lat,item.bfl_long]">
                      <l-icon
                          :icon-size="[32, 37]"
                          icon-url="/images/coin.png"
                      />

                    </l-marker>



                  </l-map>
                </div>

              </CCardBody>
            </CCollapse>
          </template>
        </CDataTable>
        <CPagination
            size="sm"
            style="float: right;width: auto;overflow: hidden;margin-top: 20px;direction: rtl;"
            @update:activePage="Change"
            v-if="Transaction.last_page>1 && TableFilter.length===0"
            :active-page.sync="currentPage"
            :pages="Transaction.last_page"/>
        <div v-if="Transaction.last_page>1 && TableFilter.length===0"  style="float: left;width: auto;color: white;margin-top: 20px">
          <span>تعداد نتایج:</span> <span>{{Transaction.total}}</span>
        </div>
      </div>
    </div>
    <CModal
        title=""
        color="info"
        fullscreen
        :closeOnBackdrop="false"
        :size="'xl'"
        :show.sync="DialogMap"
    >

        <div style="height:650px; width: 100%">
          <CSpinner v-if="loading" style="width: 100px;height: 100px;color: orange;margin: 280px 45%;" variant="warning" />

       <l-map
            ref="myMap"
            id="myMap"
            v-if="DialogMap && loading===false"
            :zoom="zoom"
            :center="center"
            @update:center="centerUpdate"
            @update:zoom="zoomUpdate"
            style="height: 100%"
        >
          <l-tile-layer
              :url="url"
              :attribution="attribution"
          />
          <l-wms-tile-layer
            :key="wmsLayer.name"
            :base-url="wmsLayer.url"
            :layers="wmsLayer.layers"
            :visible="wmsLayer.visible"
            :name="wmsLayer.name"
            :attribution="wmsLayer.attribution"
            :transparent="true"
            format="image/png"
            layer-type="base">
          </l-wms-tile-layer>
          <l-marker-cluster>
            <l-marker ref="marker2" v-for="(tran,index)  in TransactionMap.data"  v-if="tran.bfl_lat !==null && tran.bfl_long !==null " v-bind:key="index" :lat-lng="[tran.bfl_lat,tran.bfl_long]">
              <l-icon
                  :icon-size="[30, 30]"
                  icon-url="images/coin.png"
              />
              <l-popup  style="direction: rtl;background: #2a2b36">
                <div class="input-group" style="direction: rtl;width: 300px;">
                  <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">تاریخ</span>
                  <input class="form-control" disabled v-model="tran.bfl_receive_date" type="text" style="text-align: center;background: #212529;color: white" >
                </div>
                <div class="input-group" style="direction: rtl;width: 300px;">
                  <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">Pan</span>
                  <input class="form-control" disabled v-model="tran.bfl_pan" type="text" style="text-align: center;background: #212529;color: white" >
                </div>
                <div class="input-group" style="direction: rtl;width: 300px;">
                  <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">مبلغ تراکنش</span>
                  <input class="form-control" disabled v-model="tran.bfl_amount" type="text" style="text-align: center;background: #212529;color: white" >
                </div>
                <div class="input-group" style="direction: rtl;width: 300px;">
                  <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">موجودی کارت</span>
                  <input class="form-control" disabled v-model="tran.bfl_balance" type="text" style="text-align: center;background: #212529;color: white" >
                </div>
                <div class="input-group" style="direction: rtl;width: 300px;">
                  <span class="input-group-text" style="min-width: 120px;background: #212525;color: white">شناسه ترمینال</span>
                  <input class="form-control" disabled v-model="tran.bfl_terminal_code" type="text" style="text-align: center;background: #212529;color: white" >
                </div>
              </l-popup>
            </l-marker>
          </l-marker-cluster>
        </l-map>



      </div>
      <template #header>

        <h4 class="modal-title"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp;  مشاهده  </h4>

      </template>
      <template #footer>
<!--        <CButton @click="Print3()" color="primary"><CIcon name="cil-print" width="35px" height="35px"/>&nbsp;&nbsp;  چاپ</CButton>-->
        <CButton @click="DialogMap = false" color="danger">بستن</CButton>
        <!--<CButton @click="DialogSendMessage = false" color="success">ارسال</CButton>-->
      </template>
    </CModal>
  </div>
</template>

<script>
import Constant from "../../assets/Constants";
import {latLng} from "leaflet";
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
export default {
  name: "FinancialReport",
  components:{
    'l-marker-cluster': Vue2LeafletMarkerCluster,
  },
  data(){
    return {
      User:null,
      indexFleet:null,
      indexDevice:0,
      zoom: 5,
      center: latLng(35.708309, 51.380730),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
          '&copy; <a href="#">RADA Smart City</a> contributors',
      wmsLayer: {
        url: 'https://gis.shiraz.ir/shirazgis/gis_workspace/wms?',
        name: 'Weather Data',
        visible: true,
        format: 'image/png',
        layers: 'regionwms',
        transparent: true,
        attribution: 'Weather data &copy; 2012 <a href="https://mesonet.agron.iastate.edu/docs/nexrad_mosaic/">IEM Nexrad</a>',
      },
      filter:false,
      Transaction:[],
      TransactionMap:[],
      indexDeviceLog:-1,
      TableFilter:"",
      DialogMap:false,
      Fleets:[],
      Devices:[],
      FleetsOptions:[],
      DevicesOptions:[],
      Filter:{
        FleetID:-1,
        DeviceID:-1,
        ID:"",
        TransactionID:"",
        ReceiveDate:"",
        Balance:"",
        CTC:"",
        DriverPan:"",
        RRN:"",
        Amount:"",
        ReferredIDGroup:"",
        ReferredID:"",
        ResponseID:"",
        FinancialID:"",
        Pan:"",
      },
      loading:false,
      fieldObject:[{key:'bfl_id',label:'شناسه'},{key:'bfl_trns_id',label:'شناسه تراکنش'},{key:'bfl_local_date',label:'تاریخ محلی'},{key:'bfl_receive_date',label:'تاریخ دریافت'},{key:'bfl_pan',label:'رقم'},{key:'bfl_balance',label:'موجودی'},{key:'bfl_ctc',label:'ctc'}/*,{key:'bfl_terminal_id',label:'شناسه پایانه'},{key:'bfl_terminal_code',label:'کد پایانه'},{key:'bfl_driver_pan',label:'pan راننده'},{key:'bfl_online_rrn',label:'RRN'},{key:'bfl_draft_code',label:'شناسه حواله'},{key:'bfl_group_draft_code',label:'شناسه دسته ای'},
        {key:'bfl_response_code',label:'شناسه پاسخ'},{key:'bfl_response_desc',label:'توضیح پاسخ'},{key:'trn_service_point',label:'شناسه مالی'},
        {key:'bfl_lat',label:'عرض جغرافیایی'},{key:'bfl_long',label:'طول جغرافیایی'},{key:'trn_service_point',label:'شناسه دستگاه'},
        {key:'bfl_type',label:'نوع'},{key:'bfl_pan',label:'pan'}*/

      ],
      currentPage:1,
    }
  },
  mounted() {
    if(this.$session.has("User")){
      this.User= this.$session.get("User");
      this.GetTransaction(1,10);
      this.GetFleets();
      this.DevicesOptions=[];
      this.DevicesOptions.push({ value:'انتخاب نشده', text: 0 });
    }

  },
  methods:{
    zoomUpdate(zoom) {
      this.zoom = zoom;
    },
    matchHeight (height) {

      console.log("height:"+height)
      this.HeightList=(height-215)+"px";
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    GetFleets(){
      var that=this;

      this.axios
              .get(Constant.FleetByUser+this.User[0])
              .then(response => {
                that.Loading = false
                var data=response.data;
                console.log(data)
                if(data.sucsses==='true'){
                  that.Fleets=Constant.ParseServerData(data);
                  that.FleetsOptions.push({ value:'انتخاب نشده', text: 0 })
                  for(var i=0;i<that.Fleets.length;i++){
                    var fleet=that.Fleets[i];
                    that.FleetsOptions.push({ value:fleet.FleetName, text: fleet.FleetID });
                  }

                }


              }).catch(function (error) {
        console.log(error);
      })
              .finally(() =>{


              } );
    },
    SelectFleet(index){
      this.Filter.FleetID=-1;
      this.Filter.DeviceID=-1;
      this.indexFleet=index;
      this.DevicesOptions=[];
      this.DevicesOptions.push({ value:'انتخاب نشده', text: 0 });
      if(index>0&&this.Fleets.length>0){
        this.Filter.FleetID=this.Fleets[index-1].FleetID;
        this.GetDeviceByFleet(this.Fleets[index-1].FleetID);
      }
    },
    SelectDevice(index){
      this.Filter.DeviceID=-1;
      if(index>0&&this.Devices.length>0){
        this.Filter.DeviceID= this.Devices[index-1].DeviceID;
      }
    },
    GetDeviceByFleet(fleetID){
      var that=this;
      that.DevicesOptions=[];
      this.axios
              .get(Constant.DeviceByFleet+fleetID)
              .then(response => {
                that.Loading = false
                var data=response.data;
                console.log(data)
                if(data.sucsses==='true'){
                  that.Devices=Constant.ParseServerData(data);
                  that.DevicesOptions.push({ value:'انتخاب نشده', text: 0 });
                  for(var i=0;i<that.Devices.length;i++){
                    var device=that.Devices[i];
                    that.DevicesOptions.push({ value:device.CurrVehicleName, text: device.DeviceID });
                  }

                }


              }).catch(function (error) {
        console.log(error);
      })
              .finally(() =>{


              } );
    },

    GetTransaction(page,size){
      this.loading=true;
      this.currentPage=page;
      var url=Constant.TransactionLog;
      url=url.replace("$page",page);
      url=url.replace("$size",size);
      var that=this;
      this.axios
          .get(url)
          .then(response => {
            that.Loading = false
            var data=response.data;
            console.log(data)
            this.Transaction=data;

          }).catch(function (error) {
        console.log(error);
      })
          .finally(() =>{
            that.loading=false;

          } );
    },
    GetTransactionFilter(page,size){
      this.loading=true;
      this.currentPage=page;
      var url=Constant.TransactionLogSearch;
      url=url.replace("$page",page);
      url=url.replace("$size",size);
      if(this.Filter.ID.length!==0){
        url+="bfl_id%3D%3D"+this.Filter.ID+"%3B";
      }
      if(this.Filter.TransactionID.length!==0){
        url+="bfl_trns_id%3Dlk%3D"+this.Filter.TransactionID+"%3B";
      }

      if(this.Filter.Balance.length!==0){
        url+="bfl_balance%3D%3D"+this.Filter.Balance+"%3B";
      }
      if(this.Filter.CTC.length!==0){
        url+="bfl_ctc%3D%3D"+this.Filter.CTC+"%3B";
      }
      if(this.Filter.DriverPan.length!==0){
        url+="bfl_driver_pan%3Dlk%3D"+this.Filter.DriverPan+"%3B";
      }
      if(this.Filter.RRN.length!==0){
        url+="bfl_online_rrn%3Dlk%3D"+this.Filter.RRN+"%3B";
      }
      if(this.Filter.ReferredID.length!==0){
        url+="bfl_draft_code%3D%3D"+this.Filter.ReferredID+"%3B";
      }

      if(this.Filter.ReferredIDGroup.length!==0){
        url+="bfl_group_draft_code%3D%3D"+this.Filter.ReferredIDGroup+"%3B";
      }
      if(this.Filter.ResponseID.length!==0){
        url+="bfl_response_code%3D%3D"+this.Filter.ResponseID+"%3B";
      }
      if(this.Filter.FinancialID.length!==0){
        url+="bfl_financial_id%3D%3D"+this.Filter.FinancialID+"%3B";
      }
      if(this.Filter.Pan.length!==0){
        url+="bfl_pan%3D%3D"+this.Filter.Pan+"%3B";
      }
      if(this.Filter.FleetID!==-1 && this.Filter.DeviceID===-1 ){
        url+="bfl_fleet_id%3D%3D00"+this.Filter.FleetID+"%3B";
        //bfl_device_id
      }
      if(this.Filter.FleetID!==-1 && this.Filter.DeviceID!==-1 ){
        url+="bfl_device_id%3D%3D"+this.Filter.DeviceID+"%3B";
        //bfl_device_id
      }
      if(url.substr(url.length-3,url.length)==="%3B"){
        url=url.substr(0,url.length-3);
      }

      var that=this;
      this.axios
          .get(url)
          .then(response => {
            that.Loading = false
            var data=response.data;
            console.log(data)
            this.Transaction=data;

          }).catch(function (error) {
        console.log(error);
      })
          .finally(() =>{

            that.loading=false;
          } );
    },
    GetTransactionFilterMap(page,size){
      this.loading=true;
      this.currentPage=page;
      var url=Constant.TransactionLogSearch;
      url=url.replace("$page",page);
      url=url.replace("$size",size);
      if(this.Filter.ID.length!==0){
        url+="bfl_id%3D%3D"+this.Filter.ID+"%3B";
      }
      if(this.Filter.TransactionID.length!==0){
        url+="bfl_trns_id%3Dlk%3D"+this.Filter.TransactionID+"%3B";
      }

      if(this.Filter.Balance.length!==0){
        url+="bfl_balance%3D%3D"+this.Filter.Balance+"%3B";
      }
      if(this.Filter.CTC.length!==0){
        url+="bfl_ctc%3D%3D"+this.Filter.CTC+"%3B";
      }
      if(this.Filter.DriverPan.length!==0){
        url+="bfl_driver_pan%3Dlk%3D"+this.Filter.DriverPan+"%3B";
      }
      if(this.Filter.RRN.length!==0){
        url+="bfl_online_rrn%3Dlk%3D"+this.Filter.RRN+"%3B";
      }
      if(this.Filter.ReferredID.length!==0){
        url+="bfl_draft_code%3D%3D"+this.Filter.ReferredID+"%3B";
      }

      if(this.Filter.ReferredIDGroup.length!==0){
        url+="bfl_group_draft_code%3D%3D"+this.Filter.ReferredIDGroup+"%3B";
      }
      if(this.Filter.ResponseID.length!==0){
        url+="bfl_response_code%3D%3D"+this.Filter.ResponseID+"%3B";
      }
      if(this.Filter.FinancialID.length!==0){
        url+="bfl_financial_id%3D%3D"+this.Filter.FinancialID+"%3B";
      }
      if(this.Filter.Pan.length!==0){
        url+="bfl_pan%3D%3D"+this.Filter.Pan+"%3B";
      }
      if(this.Filter.FleetID!==-1 && this.Filter.DeviceID===-1 ){
        url+="bfl_fleet_id%3D%3D00"+this.Filter.FleetID+"%3B";
        //bfl_device_id
      }
      if(this.Filter.FleetID!==-1 && this.Filter.DeviceID!==-1 ){
        url+="bfl_device_id%3D%3D"+this.Filter.DeviceID+"%3B";
        //bfl_device_id
      }
      if(url.substr(url.length-3,url.length)==="%3B"){
        url=url.substr(0,url.length-3);
      }
      var that=this;
      this.axios
          .get(url)
          .then(response => {
            that.Loading = false
            var data=response.data;
            console.log(data)
            this.TransactionMap=data;

          }).catch(function (error) {
        console.log(error);
      })
          .finally(() =>{

            that.loading=false;
          } );
    },
    Change(val,val2){
      this.TableFilter="";
      console.log("OK --> ",val,val2);
      if(this.filter){
        this.GetTransactionFilter(val,10);
      }else {
        this.GetTransaction(val,10);
      }

    },
    SelectLog(item, index, columnname, event){
      if(columnname !== "details" && columnname !== "Action") {
        if (this.indexDeviceLog === -1) {
          this.indexDeviceLog = item.bfl_id;
          this.TableFilter =""+ item.bfl_id;
          if(item.LastLat!=="0.0"){
            this.center=latLng(item.bfl_lat, item.bfl_long);
            //this.$refs.myMap.mapObject.flyTo(,15,{"animate": true, "pan": {"duration": 3}});
          }
        } else {
          this.indexDeviceLog = -1;
          var that=this;
          setTimeout(function() {
            that.TableFilter ="";
          }, 700);
        }
      }else {
        console.log("EXpand")
      }
    }
  }
}
</script>

<style scoped>
  #Financial .leaflet-popup-content{
    min-height: 150px;
  }
</style>